/** IDs dos catálogos na Ameixa a atualizar ao aplicar preços (POST sku-calc-prices). */
export const PRICING_CATALOG_IDS = [1, 4];

/** A geração e a referência V4 usam o mesmo catálogo do V3. */
export const PRICING_V4_CATALOG_ID = 1;
export const PRICING_V4_CATALOG_IDS = [PRICING_V4_CATALOG_ID];

export const IN_PROMOTION_OPTIONS = [
  { value: true, label: "Em Promoção" },
  { value: false, label: "Sem Promoção" }
];

export const VARIACAO_AMEIXA_DIRECTION_OPTIONS = [
  { value: "all", label: "Todas" },
  { value: "up", label: "Somente subidas" },
  { value: "down", label: "Somente quedas" }
];

export const CURVA_OPTIONS = [
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
  { value: "null", label: "Sem curva" }
];
